import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useDossierStore } from "../../store/dossierStore";
import { cn } from "@/lib/utils";

export interface SidebarDossierPickerProps {
  clientDossiers: {
    id: string;
    nom: string;
    regime_fiscal?: string | null;
    type_comptabilite?: "tresorerie" | "engagement" | null;
  }[];
  cabinetDossiers: {
    id: string;
    nom: string;
    regime_fiscal?: string | null;
    type_comptabilite?: "tresorerie" | "engagement" | null;
  }[];
}

export default function SidebarDossierPicker({
  clientDossiers,
  cabinetDossiers,
}: SidebarDossierPickerProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { activeDossier, setActiveDossier } = useDossierStore();

  const totalDossiers = clientDossiers.length + cabinetDossiers.length;
  if (totalDossiers <= 1) return null;

  const dossiers = cabinetDossiers.length > 0 ? cabinetDossiers : clientDossiers;
  const displayNom = activeDossier?.nom || dossiers[0]?.nom || "Dossier";

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setMenuOpen(!menuOpen)}
        className="flex min-w-[140px] cursor-pointer items-center gap-1.5 rounded-md border border-[#d8deea] bg-[#eef1f7] px-2.5 py-[5px] text-xs font-medium text-[#1a2744] transition-colors hover:bg-slate-100"
      >
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-green-500" aria-hidden />
        <span className="min-w-0 truncate">{displayNom}</span>
        <span className="flex shrink-0 text-slate-400">
          <ChevronDown size={16} strokeWidth={2} />
        </span>
      </button>
      {menuOpen && (
        <>
          <div className="fixed inset-0 z-[49]" onClick={() => setMenuOpen(false)} aria-hidden />
          <div className="absolute right-0 top-full z-50 mt-1 min-w-[180px] rounded-md border border-[#e4e8ef] bg-white py-1 shadow-md">
            {dossiers.map((d) => (
              <button
                key={d.id}
                type="button"
                onClick={() => {
                  setActiveDossier(d);
                  setMenuOpen(false);
                }}
                className={cn(
                  "w-full cursor-pointer px-3.5 py-2.5 text-left text-sm font-normal text-slate-600 transition-colors hover:bg-slate-50",
                  activeDossier?.id === d.id && "bg-orange-50 font-semibold text-orange-600"
                )}
              >
                {d.nom}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
